import { useEffect, useState } from "react";

interface BackgroundVideoProps {
  wrapperClassName?: string;
  overlayClassName?: string;
  fallbackImage?: string;
}

export default function BackgroundVideo({
  wrapperClassName = "absolute inset-0",
  overlayClassName = "absolute inset-0 bg-gradient-to-b from-black/70 via-black/45 to-black/70",
  fallbackImage = "/images/11062b_c996aa7f864f4893b59aeb454ec36a0cf000.jpg.avif",
}: BackgroundVideoProps) {
  const [showVideo, setShowVideo] = useState(true);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (mediaQuery.matches) {
      setShowVideo(false);
    }
  }, []);

  return (
    <div
      className={wrapperClassName}
      style={{
        backgroundImage: `url(${fallbackImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {showVideo && (
        <video
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          poster={fallbackImage}
          disablePictureInPicture
          aria-hidden="true"
          className="absolute inset-0 w-full h-full object-cover"
          onError={() => setShowVideo(false)}
        >
          <source src="/images/grill-video.webm" type="video/webm" />
        </video>
      )}
      <div className={overlayClassName} />
    </div>
  );
}
